export const PaymentReportColumnsEnum = {
  AccountNumber: 'AccountNumber',
  AccountType: 'AccountType',
  Status: 'Status',
  ReferenceNumber: 'ReferenceNumber',
  Date: 'Date',
  Direction: 'Direction',
  TypeOfTransfer: 'TypeOfTransfer',
  TransactionReference: 'TransactionReference',
  SenderIban: 'SenderIban',
  BeneficiaryIban: 'BeneficiaryIban',
  Currency: 'Currency',
  ExchangeRate: 'ExchangeRate',
  SenderAmount: 'SenderAmount',
  BeneficiaryAmount: 'BeneficiaryAmount',
  TotalAmount: 'TotalAmount',
  Fee: 'Fee',
} as const;
export type PaymentReportColumnsEnum = (typeof PaymentReportColumnsEnum)[keyof typeof PaymentReportColumnsEnum];
